import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { IconButton } from '@flipster/react/design-system/icon-button';
import { Tooltip } from '@flipster/react/design-system/tooltip/index';
import { Datetime } from '@flipster/react/design-utils/datetime';
import InformationCircleIcon from '@flipster/react/icon/generated/InformationCircleIcon';
import { css } from '@flipster/styled-system/css';
import { center, flex, stack } from '@flipster/styled-system/patterns';
import { DateFormatter } from '@flipster/utils/datetime';

import { competitionTabsBunja } from '../../state';
import { MyRank } from './my-rank';
import { NoticeBanner } from './notice-banner';
import { RankList } from './rank-list';
import { competitionRankingsBunja } from './state';

export const Leaderboard = () => {
  const { selectedEventTabValueAtom } = useBunja(competitionTabsBunja);
  const { lastUpdatedAtAtom } = useBunja(competitionRankingsBunja);
  const selectedEventTabValue = useAtomValue(selectedEventTabValueAtom);
  const lastUpdatedAt = useAtomValue(lastUpdatedAtAtom);
  const isVolume = selectedEventTabValue === 'volume';
  const isRoi = selectedEventTabValue === 'roi';

  return (
    <section className={stack({ gap: 16 })}>
      <div
        className={flex({
          direction: { base: 'column', tablet: 'row' },
          justify: 'space-between',
          align: { base: 'flex-start', tablet: 'center' },
          gap: 12,
          pb: { base: 8, tablet: 16 },
        })}
      >
        <p
          className={css({
            textStyle: 'Title/S',
            color: 'content.default.level-5',
          })}
        >
          {isVolume ? (
            <FormattedMessage id='Competition.r251215.Volume_trading_leaderboard' />
          ) : isRoi ? (
            <FormattedMessage id='Tmp.inseok.Roi_trading_leaderboard' />
          ) : (
            <FormattedMessage id='Competition.r251218.Pnl_trading_leaderboard' />
          )}
        </p>
        <span className={center({ textStyle: 'Text/M/Regular', color: 'content.default.level-3' })}>
          <span>
            <FormattedMessage
              id='Autogen_common.r251126.s_Last_updated_formatDatetime_UTC'
              values={{
                formatDatetime: <Datetime value={lastUpdatedAt} format={DateFormatter.DateTimeSlash} isUTC />,
              }}
            />
          </span>
          <Tooltip.Root>
            <Tooltip.Trigger>
              <IconButton hierarchy='quaternary' size='small' icon={<InformationCircleIcon />} />
            </Tooltip.Trigger>
            <Tooltip.Content bottomSheetTitle={<FormattedMessage id='Competition.r251217.Last_updated' />} portal>
              <FormattedMessage id='Competition.r251215.Last_updated_desc' values={{ minute: 10 }} />
            </Tooltip.Content>
          </Tooltip.Root>
        </span>
      </div>
      <MyRank />
      <NoticeBanner />
      <RankList />
    </section>
  );
};
